import getConfig from 'next/config';
import Router from 'next/router';
import { IEventAttributes } from 'tracking/types/Event';

/**
 * [includeGlobalEventAttributes]
 * Takes an event payload object, and returns a new object that includes the input items
 * plus any common attributes that should be included in ALL tracking events (such as app_version.)
 * @returns {Object}
 */
export const includeGlobalEventAttributes = (attributes: IEventAttributes = {}): any => {
  const { publicRuntimeConfig } = getConfig();
  const { asPath: location, locale } = Router;

  return {
    ...attributes,
    location,
    locale,
    appVersion: publicRuntimeConfig.APP_VERSION,
  };
};
